import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { FormattedMessage } from "react-intl";

import { toggleArchivedDeadline } from "../../../store/actions/deadlines/company";
import { FEATURE_TOGGLE_DEADLINES_EDIT_SPLIT } from "../../../config";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import { renderStatus } from "../../../libs/deadlinesUtils";
import ArchivedClient from "./archivedClient";
import ButtonsActionDeadlines from "./buttonsAction";
import DailyTotalImports from "./dailyTotalImports";
import DeadlinesEdit from "../deadlinesEdit";
import DeadlinesRecurrency from "../deadlinesRecurrency";
import EInvoiceDescription from "./eInvoiceDescription";
import HistoryDeadline from "./history";
import LinkedDeadline from "./linked";
import PaymentInfo from "./paymentInfo";
import ReminderInfoStudio from "./reminderInfoStudio";
import SentencePayment from "./sentencePayment";
import Spinner from "../../general/spinner";
import UpdatedInfo from "./updatedInfo";
import { displaySuccessToast } from "../../../store/actions/overflowNotification";
import { getReconciliationData } from "../../../store/actions/reconciliation/movements";
import { getRecurrency } from "../../../store/actions/deadlines/detail";
import { monthsList } from "../shared";
import TsPayLogo from "../../../assets/img/logo-ts-pay_blu.svg";
import DeadlinesRegisterDrawer from "./register";

import moment from "moment";
import numeral from "numeral";

import { rruleToFrequencyOnlyText, rruleToUntilDate } from "@ts-digital/dbox-installments-engine";
import { usePermissions } from "../../../customHooks";
import PaymentOutcomeInfo from "./paymentOutcomeInfo";
import { useLocation } from "react-router-dom";

const InfoDetails = (props) => {
  const {
    classNameInfoContainer,
    isEinvoice,
    setAuthorize,
    setPayment,
    setUnauthorize,
    getDetailDetailsById,
    documentIdInPreviewHandler,
    documentIdInPreview,
    previewDeadlinesHandler,
    isFullscreenOverlay
  } = props;

  const dispatch = useDispatch();
  const location = useLocation();
  const [isPastDeadlines, setIsPastDeadlines] = useState(false);
  const [modalVisibledEdit, setModalVisibledEdit] = useState(false);
  const [visibleRegisterDrawer, setVisibleRegisterDrawer] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [paymentPlatform, setPaymentPlatform] = useState("");
  const [paymentDate, setPaymentDate] = useState("");

  const auth = useSelector((state) => state.auth);
  const company = useSelector((state) => state.company);
  const main = useSelector((state) => state.main);
  const archived = useSelector((state) =>
    state.deadlinesDetail.subjective && state.deadlinesDetail.subjective.status ? state.deadlinesDetail.subjective.status.archived : false);
  const infoDeadline = useSelector((state) => state.deadlinesDetail.subjective);
  const [isSuspended, setIsSuspended] = useState(infoDeadline && infoDeadline.payment && infoDeadline?.payment?.step === "suspended");
  const [modalVisible, setModalVisible] = useState(false);
  const isGettingDeadlines = useSelector((state) => state.deadlinesDetail.isGettingDeadlines);

  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;
  const accountantUuidSelected = main.accountantUuidSelected;
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const companyUuidSelected = main.companyUuidSelected;
  const myType = main.myType;

  let accountantSelectedRagSoc = "";
  let companyObj = company.companies.find((el) => {
    return el.codiceFiscale === companySelected;
  });

  if (companyObj && companyObj.commercialistiList) {
    accountantSelectedRagSoc = companyObj.commercialistiList.find((el) => {
      return el.codiceFiscale === accountantSelected;
    }).ragioneSociale;
  }

  // Nel caso in cui ricarico la pagina senza passare da detail
  if (isSuspended === null && infoDeadline) {
    setIsSuspended(infoDeadline.payment && infoDeadline?.payment?.step === "suspended");
  }

  const dateCurrent = useSelector((state) =>
    state.deadlinesDetail.subjective && state.deadlinesDetail.subjective.date ? state.deadlinesDetail.subjective.date : null);
  const filename = useSelector((state) =>
    state.deadlinesDetail.subjective && state.deadlinesDetail.subjective.attachmentsDetail
      ? state.deadlinesDetail.subjective.attachmentsDetail[0].filename
      : null);

  const readOnly = useSelector((state) =>
    state.deadlinesDetail.subjective && state.deadlinesDetail.subjective.status ? state.deadlinesDetail.subjective.status.readOnly : false);

  const currentPermissions = useSelector((state) => state.currentPermissions);

  const deadlinesDetail = useSelector((state) => state.deadlinesDetail);

  useEffect(() => {
    if (infoDeadline.bankTransactionCount > 0) {
      dispatch(getReconciliationData(null, infoDeadline.id));
    }
  }, []);

  useEffect(() => {
    if (infoDeadline && infoDeadline.recurrence) {
      dispatch(getRecurrency({
        recurrenceId: infoDeadline && infoDeadline.recurrence && infoDeadline.recurrence.id ? infoDeadline.recurrence.id : null,
        first: "200"
      }));
    }
    setPaymentStatus(infoDeadline?.payment?.execution?.status);
    setPaymentType(infoDeadline?.payment?.execution?.ref?.type);
    setPaymentPlatform(infoDeadline?.payment?.execution?.platform);
    setPaymentDate(infoDeadline?.payment?.execution?.date);
  }, [infoDeadline]);

  useEffect(() => {
    if (!dateCurrent) return;
    setIsPastDeadlines(moment(new Date()).diff(props.infoObj.date) > 0);
  }, [dateCurrent]);

  useEffect(() => {
    setIsSuspended(infoDeadline && infoDeadline.payment && infoDeadline?.payment?.step === "suspended");
  }, [infoDeadline]);

  const onChange = () => {
    getDetailDetailsById(infoDeadline.id);
  };

  const deadlineId = deadlinesDetail?.subjective.id;

  const onToggleArchivedDeadline = () => {
    dispatch(toggleArchivedDeadline(infoDeadline, () => onChange()));
  };

  function setSuspended() {
    setIsSuspended(!isSuspended);
    let message = "La scadenza è stata riattivata";
    if (isSuspended) {
      setPayment(
        "due", null, null
      );
    } else {
      setPayment(
        "suspended", null, null
      );
      message = "La scadenza è stata sospesa";
    }
    dispatch(displaySuccessToast(message, ""));
  }

  function convert(str) {
    const date = new Date(str);
    const month = monthsList[date.getMonth()].text;
    const day = ("0" + date.getDate()).slice(-2);
    return [day, month, date.getFullYear()].join(" ");
  }

  const { isAuthorizationPermission, isAuthorizationFiscalPermission } = usePermissions(currentPermissions);

  if (isGettingDeadlines) return <Spinner size="large" />;
  else if (!infoDeadline) return null;

  let suspendedIcon = !isSuspended ? "stop-circle" : "play-circle";
  let suspendedTitle = !isSuspended ? "Sospendi" : "Riattiva";
  const isPayed =
      infoDeadline?.payment?.step !== "to_be_paid" && infoDeadline?.payment?.step !== "to_be_collected" && infoDeadline?.payment?.step !== "suspended";
  let freq = "";
  let end = "";
  if (infoDeadline.recurrence && infoDeadline.recurrence.rule) {
    freq = rruleToFrequencyOnlyText(infoDeadline.recurrence.rule);
    end = convert(rruleToUntilDate(infoDeadline.recurrence.rule));
  }
  const isArchived = infoDeadline?.status?.archived;

  const onCloseRegisterDrawer = () => {
    getDetailDetailsById(deadlineId);
    setVisibleRegisterDrawer(false);
    navigate(`/scadenza/${infoDeadline.id}`, { state: { fromList: false }, replace: true });       
  };

  return (
    <div className={"containerInfoDeadline " + classNameInfoContainer}>
      <ArchivedClient archived={archived} myType={myType} onToggleArchivedDeadline={onToggleArchivedDeadline} />
      <div
        style={{
          borderBottom: "1px solid #c9d9e8",
          padding: "16px 0 8px 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end"
        }}
      >
        <div
          className="blockCeil"
          style={{
            color: infoDeadline && infoDeadline.status && infoDeadline.status.transformation ? "#c1c1c4" : "inherit"
          }}
        >
          <div style={{ minHeight: 24, minWidth: 55.7 }}>
            {infoDeadline.payment &&
            ((infoDeadline?.payment?.step && ["paid", "verified", "failed", "collected"].indexOf(infoDeadline?.payment?.step) > -1) ||
              (!infoDeadline?.payment?.compensation && infoDeadline?.totalAmount < 0) ||
              infoDeadline?.scope === "debt") ? (
                <FormattedMessage id="deadlines.pay" />
              ) : infoDeadline.totalAmount === 0 || infoDeadline?.payment?.compensation ? (
                <FormattedMessage id="deadlines.balance" />
              ) : (
                <FormattedMessage id="deadlines.collect" />
              )}
          </div>
          <div className="marked">{numeral(Math.abs(infoDeadline?.totalAmount)).format("0,0.00")} €</div>
        </div>
        <div
          className="blockCeil"
          style={{
            color: infoDeadline.status.transformation ? "#c1c1c4" : "inherit"
          }}
        >
          <div>{isPastDeadlines ? "Il" : "Entro"}</div>
          <div className="marked">{moment(dateCurrent).format(DATE_FORMAT_FOR_DISPLAY)}</div>
        </div>
        <div className="blockCeil">
          <div>{renderStatus(infoDeadline)}</div>
        </div>
        <div style={{ display: "flex" }} className="blockCell">
          {myType !== "STUDIO" &&
          infoDeadline._links.set_payment_paid &&
          isAuthorizationPermission &&
          !isPayed &&
          !isArchived &&
          !isFullscreenOverlay &&
          infoDeadline.scope !== "fiscal_social_security" ? (
              <div
                style={{ marginRight: "25px" }}
                onClick={(e) => {
                  setSuspended();
                }}
              >
                <Tooltip color={"rgb(0, 80, 117)"} title={suspendedTitle}>
                  <FontAwesomeIcon
                    style={{
                      color: "#0090d1",
                      fontSize: "16px",
                      marginRight: "4px",
                      cursor: "pointer"
                    }}
                    icon={["far", suspendedIcon]}
                  />
                </Tooltip>
              </div>
            ) : (
              <div></div>
            )}
          <div
            className="blockCeil"
            onClick={(e) => {
              setModalVisibledEdit(true);
              if (window.aptrinsic) {
                window.aptrinsic("track", "digital-box:DEADLINES-MODIFY");
              }
            }}
          >
            {FEATURE_TOGGLE_DEADLINES_EDIT_SPLIT &&
              !infoDeadline.status.transformation &&
              !isFullscreenOverlay &&
              infoDeadline?.payment?.step !== "suspended" &&
              infoDeadline.scope !== "fiscal_social_security" &&
              ["paid", "verified", "failed", "pending", "collected"].indexOf(infoDeadline?.payment?.step) < 0 && (
              <FontAwesomeIcon
                style={{
                  color: "#0090d1",
                  fontSize: "16px",
                  marginRight: "4px",
                  cursor: "pointer"
                }}
                icon={["far", "edit"]}
              />
            )}
          </div>
        </div>
      </div>
      {infoDeadline.recurrence && (
        <div style={{ display: "flex", marginTop: "5px" }}>
          <div style={{ marginRight: "5px" }}>
            <FormattedMessage id="deadlines.pages.detail.repeats" /> <b>{freq}</b> <FormattedMessage id="deadlines.pages.detail.until" /> <b>{end}</b>.
          </div>
          <div
            onClick={(e) => {
              setModalVisible(true);
            }}
            style={{
              display: "flex",
              alignSelf: "flex-end",
              alignItems: "baseline",
              fontSize: 16,
              color: "#0090d1",
              width: "48%",
              cursor: "pointer"
            }}
          >
            <FontAwesomeIcon icon={["far", "external-link"]} style={{ marginRight: 8 }} />
            <FormattedMessage id="actions.showAll" />
          </div>
        </div>
      )}
      {infoDeadline.bankTransactionCount > 0 ? (
        <div style={{ display: "flex", marginTop: "20px" }}>
          <div>
            <FormattedMessage id="deadlines.pages.detail.reconciledDeadline" />
          </div>
          {!isFullscreenOverlay ? (
            <div onClick={() => setVisibleRegisterDrawer(!visibleRegisterDrawer)} style={{ marginLeft: "20px" }}>
              <FontAwesomeIcon color="#0090d1" cursor="pointer" icon={["far", "university"]} />
            </div>
          ) : (
            <div></div>
          )}{" "}
        </div>
      ) : null}
      {(infoDeadline.bankTransactionCount > 0 && visibleRegisterDrawer) || (infoDeadline.bankTransactionCount > 0 && location?.state?.fromList) ? (
        <div>
          <DeadlinesRegisterDrawer
            accountantUuidSelected={accountantUuidSelected}
            companyUuidSelected={companyUuidSelected}
            onClose={() => {
              onCloseRegisterDrawer();
            }}
            onCloseWithResidue={() => {}}
            visibleRegisterDrawer={true}
            onPaymentComplete={() => {}}
            paymentType={""}
            isFiscalSocialSecurity={infoDeadline.scope === "fiscal_social_security"}
            setPayment={() => {}}
            splitDeadlines={() => {}}
            reconciliated={infoDeadline.bankTransactionCount > 0}
          />
        </div>
      ) : null}

      {!infoDeadline.status.transformation ? (
        <Fragment>
          <DailyTotalImports />
          <EInvoiceDescription
            documentIdInPreviewHandler={documentIdInPreviewHandler}
            documentIdInPreview={documentIdInPreview}
            previewDeadlinesHandler={previewDeadlinesHandler}
            isFullscreenOverlay={isFullscreenOverlay}
          />
          <div>
            <LinkedDeadline myType={myType} isFullscreenOverlay={isFullscreenOverlay} />
          </div>
          <div>
            <HistoryDeadline isFullscreenOverlay={isFullscreenOverlay} />
          </div>
          <br />
          {paymentPlatform !== "tspay" && <PaymentInfo />}
          <UpdatedInfo />
          <SentencePayment myType={myType} />
          <ReminderInfoStudio />
          <h1>{filename}</h1>
          {!readOnly && ((isAuthorizationPermission && infoDeadline.scope !== "fiscal_social_security") || (isAuthorizationFiscalPermission && infoDeadline.scope === "fiscal_social_security")) && !main.widgets.fullscreenOverlay.visible && paymentStatus !== null && paymentPlatform === "tspay" &&(
            <PaymentOutcomeInfo
              paymentStatus={paymentStatus}
              paymentType={paymentType}
              // accountNumber={accountNumber}
              // bankAccountName={bankAccountName}
              paymentDate={paymentDate}
              tsPayLogo={TsPayLogo}
            />
          )}

          {!readOnly &&
            (((isAuthorizationPermission && infoDeadline.scope !== "fiscal_social_security") || (isAuthorizationFiscalPermission && infoDeadline.scope === "fiscal_social_security")) || myType === "STUDIO") &&
            !main.widgets.fullscreenOverlay.visible &&
            (paymentStatus === "failed" || paymentStatus === null) &&(
            <div id="deadlineActions">
              <ButtonsActionDeadlines
                hasAuthorize={infoDeadline._links.authorize ? true : false}
                hasReject={infoDeadline._links.reject ? true : false}
                updatePayment={infoDeadline._links.set_payment_paid ? true : false}
                accountantSelectedRagSoc={accountantSelectedRagSoc}
                counterPart={infoDeadline.counterpart.description}
                isPayed={
                  infoDeadline?.payment?.step !== "to_be_paid" &&
                    infoDeadline?.payment?.step !== "to_be_collected" &&
                    infoDeadline?.payment?.step !== "suspended"
                }
                isItemPays={infoDeadline.payment.type === "item_pays"}
                isManagerPays={infoDeadline.payment.type === "manager_pays"}
                authorizeChoice={infoDeadline.status.authorized !== false || infoDeadline.status.rejected !== false}
                isFiscalSocialSecurity={infoDeadline.scope === "fiscal_social_security"}
                isConfirmed={infoDeadline.status.confirmed === true}
                isCompensation={infoDeadline.payment.compensation === true}
                isSuspended={isSuspended}
                myType={myType}
                isStudio={myType === "STUDIO"}
                isToPay={infoDeadline.totalAmount < 0}
                isPastDeadlines={isPastDeadlines}
                isInvoice={infoDeadline.scope === "debt" || infoDeadline.scope === "credit"}
                setAuthorize={setAuthorize}
                setPayment={setPayment}
                setUnauthorize={setUnauthorize}
                paymentType={infoDeadline.payment}
                isAuthorizationPermission={isAuthorizationPermission}
                isAuthorizationFiscalPermission={isAuthorizationFiscalPermission}
                infoDeadline={infoDeadline}
                auth={auth}
                clientIdSelected={clientIdSelected}
                accountantIdSelected={accountantIdSelected}
                accountantUuidSelected={accountantUuidSelected}
                companyUuidSelected={companyUuidSelected}
                getDetailDetailsById={getDetailDetailsById}
                reconciliated={infoDeadline.bankTransactionCount > 0}
              />
            </div>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <div style={{ color: "#152935", margin: "16px 0" }}>
            {infoDeadline.status.transformation === "split" ? <FormattedMessage id="deadlines.split.advice" /> : null}
          </div>
          <div style={{ color: "#152935", margin: "48px 0" }}>
            <div style={{ marginBottom: "16px" }}>
              <FormattedMessage id="deadlines.adviceTransformation" />
            </div>
            {isEinvoice ? <EInvoiceDescription documentIdInPreview={documentIdInPreview} previewDeadlinesHandler={previewDeadlinesHandler} /> : null}
          </div>
        </Fragment>
      )}
      <DeadlinesEdit
        accountantSelected={accountantSelected}
        accountantIdSelected={accountantIdSelected}
        auth={auth}
        companySelected={companySelected}
        clientIdSelected={clientIdSelected}
        closeModalFunc={(e) => {
          setModalVisibledEdit(false);
        }}
        modalVisibled={modalVisibledEdit}
        myType={myType}
        getDetailDetailsById={getDetailDetailsById}
      />
      <DeadlinesRecurrency
        closeModalFunc={(e) => {
          setModalVisible(false);
        }}
        modalVisible={modalVisible}
      />
    </div>
  );
};
export default InfoDetails;
